import React from 'react';
import { Checkbox, Field, Form, Input, Mapper, Text, TextType, UnboxedAutocomplete } from '@philips-internal/oswald-ui-components';
import { isContentfulString } from '@philips-internal/oswald-ui-utils';
function createDataEntry(field) {
    if (field.type === 'checkbox') {
        return (React.createElement(Checkbox, { label: field.label, name: field.name, uuid: `dialog-service-prompt-checkbox-${field.name}` }));
    }
    if (field.type === 'multiselect') {
        return (React.createElement(UnboxedAutocomplete, { data: field.options?.map(option => ({ option })) ?? [], entry: "option", localData: true, minSearchLength: 0, multiselect: true, previewAmount: 3, primaryKey: "option", queryKey: "option", uuid: `dialog-service-prompt-select-${field.name}` },
            React.createElement(Mapper, { map: { value: 'option' } },
                React.createElement(Text, { type: TextType.SECONDARY }))));
    }
    return (React.createElement(Input, { autoFocus: true, autoSelect: true }));
}
function createField(field) {
    return (React.createElement(Field, { alwaysShowLabel: true, entry: field.name, key: field.name, label: field.label, uuid: `dialog-service-prompt-field-${field.name}`, width: 12 }, createDataEntry(field)));
}
function createForm(props) {
    const fieldElements = props.fields.map(createField);
    return (React.createElement(Form, { data: props.data, disabled: true, editing: true, locked: true, onChange: props.onFormChange, uuid: "dialog-service-prompt-form" }, fieldElements));
}
function createText(description) {
    if (!isContentfulString(description)) {
        return null;
    }
    return React.createElement(Text, { value: description });
}
function createPromptContent(props) {
    return (React.createElement("div", { className: "c-oswald-dialog__content" },
        createText(props.description),
        createForm(props)));
}
export { createPromptContent, };
//# sourceMappingURL=dialog-service-utils.js.map